export default [
  {
    id: 'profile',
    title: 'プロフィール',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'address',
    title: '住所',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'contacts',
    title: '連絡先',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'skills-to-use',
    title: 'スキル',
    // previewJumpId: 'preview-page-02'
    previewJumpId: 'skills'
  },
  {
    id: 'job-history',
    title: '職務経歴',
    previewJumpId: 'job-history'
  },
  {
    id: 'job-summary',
    title: '職務要約',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'pr-message',
    title: '自己PR',
    previewJumpId: 'pr-message'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'confirm',
    title: '確認',
    previewJumpId: 'confirm-button'
  },
  {
    id: 'output',
    title: '完了',
    previewJumpId: 'preview-page-01'
  }
]
